export const Citys = [
    'TETOVO', 'GOSTIVAR', 'SKOPJE', 'STRUGA', 'OHRID', 'GEVGELIA','KUMANOVO','PRILEP','STRUMICA','SHTIP','VELES','VALONDOVO'
];
